import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { BsSliders, BsShare } from 'react-icons/bs'; // تمت إضافة BsShare
import { IoChevronBack } from 'react-icons/io5';
import logo from '../../assest/images/logoAlbarede.png';
import './Laws.css';
import { IoMdSearch } from "react-icons/io";
import { Link, useLocation } from 'react-router-dom';
import { FaRegFileAlt } from "react-icons/fa";
import { LuTag } from "react-icons/lu";
import { BsBookmarks } from "react-icons/bs";
import { BsBoxSeam, BsCalendar, BsFileEarmarkText, BsBuilding, BsCheckCircle, BsXCircle } from 'react-icons/bs';
import { FilterDropdown, LawCardSkeleton } from '../../Components/index';
import { GrHomeRounded } from "react-icons/gr";
import { useTranslation } from 'react-i18next';
import { FaApple } from "react-icons/fa";
import { RiGooglePlayFill } from "react-icons/ri";
import lawnexLogo from '../../assest/images/lawnexLogo.svg';

const STORAGE_KEY = 'laws_search_state'; //  مفتاح التخزين الثابت
// دالة تحويل النص إلى HTML منظم
function formatArticleText(text) {
    if (!text) {
        return null;
    }

    const lines = text.split('\n');
    let output = [];
    let currentList = null;
    let isUl = false;

    lines.forEach((line, index) => {
        const trimmedLine = line.trim();
        if (!trimmedLine) {
            return;
        }

        const isLetteredOl = /^- *[أ-ي]\s*-/.test(trimmedLine);
        const isNumberedOl = /^- *\d+\s*-/.test(trimmedLine);
        const isBulletUl = /^- *\s*\-/.test(trimmedLine);

        if (isLetteredOl || isNumberedOl || isBulletUl) {
            const cleanText = trimmedLine.replace(/^- *(\s*\-|\d+|\w+)\s*-/, '').trim();

            if (!currentList || (isBulletUl && !isUl) || (!isBulletUl && isUl)) {
                if (currentList) {
                    output.push(currentList);
                }
                isUl = isBulletUl;
                currentList = isUl ? <ul key={`list-${index}`}></ul> : <ol key={`list-${index}`}></ol>;
            }

            // تحقق من وجود props.children قبل الدفع إليه
            if (currentList && currentList.props.children) {
                 // يجب إنشاء قائمة جديدة بمجرد تغيير نوع القائمة
                const newLi = <li key={index}>{cleanText}</li>;
                // بما أن مكونات React غير قابلة للتغيير (Immutable)، يجب استنساخ العنصر وتعديل الخصائص (children)
                currentList = React.cloneElement(currentList, {
                    children: [...currentList.props.children, newLi]
                });
            }


        } else {
            if (currentList) {
                output.push(currentList);
                currentList = null;
            }
            output.push(<p key={index}>{trimmedLine}</p>);
        }
    });

    if (currentList) {
        output.push(currentList);
    }

    if (output.length === 0) {
        return <p>{text}</p>;
    }

    return output;
}

function highlightSearchTerms(text, term) {
    if (!text || !term || term.trim() === '') {
        return text;
    }
    const terms = term.trim().split(/\s+/).filter(t => t.length > 0);
    const pattern = new RegExp(`(${terms.join('|')})`, 'gi');
    return text.split(pattern).map((part, index) =>
        pattern.test(part) && terms.some(t => part.toLowerCase() === t.toLowerCase())
            ? <mark key={index}>{part}</mark>
            : part
    );
}

function Laws() {
    const { t, i18n } = useTranslation();
    // دالة مساعدة لجلب الحالة المحفوظة من sessionStorage
    const getInitialState = (key) => {
        try {
            const savedState = sessionStorage.getItem(STORAGE_KEY);
            if (savedState) {
                const state = JSON.parse(savedState);
                return state[key] !== undefined ? state[key] : '';
            }
        } catch (error) {
            console.error("Error reading from sessionStorage", error);
        }
        return '';
    };
    const [searchTerm, setSearchTerm] = useState(getInitialState('searchTerm'));
    const [categoryFilter, setCategoryFilter] = useState(getInitialState('categoryFilter'));
    const [typeFilter, setTypeFilter] = useState(getInitialState('typeFilter'));
    const [sourceFilter, setSourceFilter] = useState(getInitialState('sourceFilter'));
    const [yearFilter, setYearFilter] = useState(getInitialState('yearFilter'));
    const [enforcedFilter, setEnforcedFilter] = useState(getInitialState('enforcedFilter'));
    const [laws, setLaws] = useState([]);
    const [allLaws, setAllLaws] = useState([]);
    const [loading, setLoading] = useState(false);
    // يحدد ما إذا كان هناك أي بحث/تصفية مُطبّقة على الإطلاق
    const isAnyFilterActive = searchTerm.trim().length > 0 || categoryFilter || typeFilter || sourceFilter || yearFilter || enforcedFilter;

    // يحدد ما إذا كنا في وضع البحث النصي الذي يتطلب عرض المقتطفات
    const isTextSearchMode = searchTerm.trim().length > 0;

    const [categories, setCategories] = useState([]);
    const [types, setTypes] = useState([]);
    const [sources, setSources] = useState([]);
    const [years, setYears] = useState([]);
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);

    const resultsPerPage = 6;
    const debounceTimerRef = useRef(null);
    const [totalResults, setTotalResults] = useState(0);
    const location = useLocation(); // **استخدام hook لتحديد المسار الحالي**
    const searchContainerRef = useRef(null);
    const totalPages = Math.ceil(totalResults / resultsPerPage);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const isIconMode = window.innerWidth <= 992;
    
    const checkInitialFocus = () => {
        const savedState = sessionStorage.getItem(STORAGE_KEY);
        if (savedState) {
            const state = JSON.parse(savedState);
            // تكون القيمة الأولية لـ isFocused هي true إذا كان أي من متغيرات البحث/التصفية له قيمة محفوظة
            return (
                (state.searchTerm && state.searchTerm.trim().length > 0) ||
                !!state.categoryFilter || 
                !!state.typeFilter || 
                !!state.sourceFilter || 
                !!state.yearFilter || 
                !!state.enforcedFilter
            );
        }
        return false; // القيمة الافتراضية: لا يوجد تركيز (وضع الشعار الكبير)
    };
    
    // **التعديل هنا:** استخدام الدالة الجديدة لتعيين القيمة الأولية
    const [isFocused, setIsFocused] = useState(checkInitialFocus());
    
    // حالة رسالة التنبيه (Toast) للمشاركة
    const [shareMessage, setShareMessage] = useState({ visible: false, text: '', type: 'success' });

    
    
        // **3. استرجاع الصفحة الحالية**
    const [currentPage, setCurrentPage] = useState(Number(getInitialState('currentPage')) || 1);

    const saveSearchState = useCallback(() => {
        const stateToSave = {
            searchTerm,
            categoryFilter,
            typeFilter,
            sourceFilter,
            yearFilter,
            enforcedFilter,
            currentPage,
        };
        try {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
        } catch (error) {
            console.error("Error saving to sessionStorage", error);
        }
    }, [searchTerm, categoryFilter, typeFilter, sourceFilter, yearFilter, enforcedFilter, currentPage]);

    // **4. حفظ الحالة كلما تغيرت أي من المتغيرات ذات الصلة**
    useEffect(() => {
        saveSearchState();
    }, [searchTerm, categoryFilter, typeFilter, sourceFilter, yearFilter, enforcedFilter, currentPage, saveSearchState]);
    // useEffect لجلب بيانات الفلاتر عند تحميل الصفحة
    useEffect(() => {
        const fetchFilters = async () => {
            // ... (جلب الفلاتر: categoriesRes, typesRes, sourcesRes, yearsRes) ...
             try {
                // جلب بيانات الفلاتر... (لا تحتاج لتعديل)
                // const categoriesRes = await axios.get('http://localhost/server/testServer/get_filters.php?type=categories');
                const categoriesRes = await axios.get('https://www.albarede.com/server/get_filters.php?type=categories');
                setCategories(categoriesRes.data);
                // const typesRes = await axios.get('http://localhost/server/testServer/get_filters.php?type=types');
                const typesRes = await axios.get('https://www.albarede.com/server/get_filters.php?type=types');
                setTypes(typesRes.data);
                // const sourcesRes = await axios.get('http://localhost/server/testServer/get_filters.php?type=sources');
                const sourcesRes = await axios.get('https://www.albarede.com/server/get_filters.php?type=sources');
                setSources(sourcesRes.data);
                // const yearsRes = await axios.get('http://localhost/server/testServer/get_filters.php?type=years');
                const yearsRes = await axios.get('https://www.albarede.com/server/get_filters.php?type=years');
                setYears(yearsRes.data);
                
                // **جلب الحالة المحفوظة لتحديد ما إذا كان البحث/التصفية سيعاد تطبيقه**
                const savedState = sessionStorage.getItem(STORAGE_KEY);
                let initialLawsData = [];
                let shouldRunSearch = true;

                if (savedState) {
                    const state = JSON.parse(savedState);
                    const isAnyFilterSaved = state.searchTerm || state.categoryFilter || state.typeFilter || state.sourceFilter || state.yearFilter || state.enforcedFilter;
                    
                    if (isAnyFilterSaved) {
                        // إذا كان هناك بحث أو تصفية محفوظة، سنعتمد على useEffect التالي لتشغيل handleSearch
                        shouldRunSearch = true; 
                    } else {
                        // إذا كانت الفلاتر فارغة، نحضر كل القوانين
                        // const initialLawsRes = await axios.get('http://localhost/server/testServer/search.php');
                        const initialLawsRes = await axios.get('https://www.albarede.com/server/search.php');
                        initialLawsData = initialLawsRes.data.laws;
                        setAllLaws(initialLawsData);
                        setTotalResults(initialLawsData.length);
                        // بما أن الفلاتر فارغة، يتم عرض الافتراضي.
                        shouldRunSearch = false;
                    }
                } else {
                    // إذا لم تكن هناك حالة محفوظة على الإطلاق، نحضر كل القوانين
                    // const initialLawsRes = await axios.get('http://localhost/server/testServer/search.php');
                    const initialLawsRes = await axios.get('https://www.albarede.com/server/search.php');
                    initialLawsData = initialLawsRes.data.laws;
                    setAllLaws(initialLawsData);
                    setTotalResults(initialLawsData.length);
                    shouldRunSearch = false;
                }
                
                // إذا لم يكن هناك بحث يجب تشغيله، تأكد من تعيين القوانين المعروضة
                if (!shouldRunSearch && Array.isArray(initialLawsData)) {
                    setLaws(initialLawsData.slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage));
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchFilters();
        return () => {
        };
    }, []);

    // Pagination
    useEffect(() => {
        const startIndex = (currentPage - 1) * resultsPerPage;
        const endIndex = startIndex + resultsPerPage;
        setLaws(allLaws.slice(startIndex, endIndex));
    }, [currentPage, allLaws, resultsPerPage]);


    // دالة المشاركة (Share)
    const handleShare = useCallback((lawTitle, lawId) => {
        const shareUrl = `${window.location.origin}/law/${lawId}`;
        const shareText = `قانون: ${lawTitle}`;

        const showToast = (text, type = 'success') => {
            setShareMessage({ visible: true, text, type });
            setTimeout(() => setShareMessage({ visible: false, text: '', type: 'success' }), 3000);
        };

        if (navigator.share) {
            navigator.share({
                title: lawTitle,
                text: shareText,
                url: shareUrl,
            }).catch(error => {
                if (error.name !== 'AbortError') {
                    console.error('Error sharing:', error);
                    showToast('فشل المشاركة.', 'error');
                }
            });
        } else {
            // Fallback: Copy URL to clipboard
            try {
                // استخدام API الحديث للنسخ مع محاولة الرجوع للطرق القديمة
                navigator.clipboard.writeText(shareUrl)
                    .then(() => showToast('تم نسخ الرابط!'))
                    .catch(() => {
                        // Fallback (document.execCommand('copy'))
                        const dummyElement = document.createElement("textarea");
                        dummyElement.value = shareUrl;
                        document.body.appendChild(dummyElement);
                        dummyElement.select();
                        document.execCommand("copy");
                        document.body.removeChild(dummyElement);
                        showToast('تم نسخ الرابط!');
                    });
            } catch (error) {
                console.error("Clipboard API failed:", error);
                showToast('فشل نسخ الرابط.', 'error');
            }
        }
    }, []);


    const handleSearch = useCallback(async (isInitialLoad = false, skipApiCall = false) => {
        // التأكد من وجود شيء للبحث عنه أو تصفية (باستثناء التحميل الأولي)
        const isCurrentlyAnyFilterActive = searchTerm.trim().length > 0 || categoryFilter || typeFilter || sourceFilter || yearFilter || enforcedFilter;
        
        // إذا لم يكن تحميلًا أولياً، ولكن حقل البحث والفلاتر فارغة، فلا داعي للبحث.
        if (!isInitialLoad && !isCurrentlyAnyFilterActive && allLaws.length > 0) {
            setLaws(allLaws.slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage));
             setTotalResults(allLaws.length);
             setLoading(false);
            return;
        }
        if (skipApiCall && allLaws.length > 0) {
            setLaws(allLaws.slice((currentPage - 1) * resultsPerPage, currentPage * resultsPerPage));
            setTotalResults(allLaws.length);
            setLoading(false);
            return;
        }
        setLoading(true);
        
        try {
            // const response = await axios.get(`http://localhost/server/testServer/search.php?q=${searchTerm}&category=${categoryFilter}&type=${typeFilter}&source=${sourceFilter}&year=${yearFilter}&enforced=${enforcedFilter}`);
            const response = await axios.get(`https://www.albarede.com/server/search.php?q=${searchTerm}&category=${categoryFilter}&type=${typeFilter}&source=${sourceFilter}&year=${yearFilter}&enforced=${enforcedFilter}`);
            const fetchedLaws = response.data.laws;

            if (Array.isArray(fetchedLaws)) {
                setAllLaws(fetchedLaws);
                setTotalResults(fetchedLaws.length);
                setCurrentPage(1);
            } else {
                setAllLaws([]);
                setTotalResults(0);
            }
        } catch (error) {
            console.error("Error fetching search results:", error);
            setAllLaws([]);
        } finally {
            setLoading(false);
            setIsSidebarOpen(false);
            // إغلاق الفلاتر على الجوال بعد البحث/التصفية
            if (window.innerWidth <= 768) {
                setShowFiltersMobile(false);
            }
        }
    }, [searchTerm, categoryFilter, typeFilter, sourceFilter, yearFilter, enforcedFilter]);

    // **useEffect المُعدَّل (الخاص بالـ Debounce)**
useEffect(() => {
    // نستخدم مؤقت (Debounce) لتقليل عدد طلبات الشبكة أثناء الكتابة السريعة
    clearTimeout(debounceTimerRef.current);
    
    // **ملاحظة:** لا نضع currentPage أو allLaws في التبعيات هنا،
    // نركز فقط على متغيرات البحث/التصفية لتجنب تكرار التشغيل غير الضروري.

    debounceTimerRef.current = setTimeout(() => {
        // التحقق مما إذا كان هناك بحث أو تصفية نشطة حالياً
        const isCurrentlyAnyFilterActive = searchTerm.trim().length > 0 || categoryFilter || typeFilter || sourceFilter || yearFilter || enforcedFilter;

        if (isCurrentlyAnyFilterActive) {
            // **إذا كان هناك أي بحث/تصفية، قم بتشغيل البحث (جلب البيانات الجديدة)**
            handleSearch();
        } else if (allLaws.length === 0) { 
             // إذا لم يكن هناك فلاتر والقائمة فارغة، قم بتحميل جميع القوانين
             handleSearch(true); // تشغيل التحميل الأولي
        }
        // **قم بإزالة الجزء الذي كان يعيد تعيين setLaws هنا**
        // لأن إعادة تعيين setLaws ضمن مؤقت يسبب الرجفان.

    }, 500); // تأخير نصف ثانية

    return () => clearTimeout(debounceTimerRef.current);
// **هنا يجب وضع فقط متغيرات البحث/التصفية**
}, [searchTerm, categoryFilter, typeFilter, sourceFilter, yearFilter, enforcedFilter, handleSearch, allLaws.length]);

    useEffect(() => {
    // هذا التأثير سيتم تشغيله فوراً عند تغيير الصفحة أو تحديث قائمة النتائج الكاملة (allLaws)
    if (Array.isArray(allLaws) && allLaws.length > 0) {
        const startIndex = (currentPage - 1) * resultsPerPage;
        const endIndex = startIndex + resultsPerPage;
        
        // **هذا هو التحديث الذي يجب أن يكون فورياً وليس مؤجلاً**
        setLaws(allLaws.slice(startIndex, endIndex));
    } else if (allLaws.length === 0 && !loading) {
         // لعرض رسالة "لا توجد نتائج بحث"
         setLaws([]);
    }
    // **ملاحظة:** يتم تشغيل هذا بعد اكتمال handleSearch (الذي يحدث setAllLaws)
    // أو عند النقر على أزرار الترحيل (التي تحدث setCurrentPage).
}, [currentPage, allLaws, resultsPerPage, loading]);
    
    function handleEnterPress(event) {
    if(event.key === 'Enter') {
        // 1. إلغاء المؤقت المخزن في useRef
        clearTimeout(debounceTimerRef.current);
        
        // 2. تشغيل البحث مباشرةً.
        handleSearch();
        
        // 3. تفعيل وضع التركيز
        setIsFocused(true)
    }
    }
    const handleNextPage = () => {
        if (currentPage * resultsPerPage < totalResults) {
            setCurrentPage(prev => prev + 1); // استخدام دالة تحديث الحالة
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1); // استخدام دالة تحديث الحالة
        }
    };
    const LinkToLaw = ({ lawId, children }) => {
        // حفظ الحالة قبل الانتقال مباشرة
        const handleClick = () => {
             saveSearchState(); // ضمان حفظ الحالة قبل التوجيه
        };
        
        return <Link to={`/law/${lawId}`} onClick={handleClick}>{children}</Link>;
    };

    return (
        <div className={`laws_page ${isFocused ? 'focused' : ''}`}>
            
            {/* رسالة التنبيه (Share Toast) */}
            {shareMessage.visible && (
                <div className={`share_toast ${shareMessage.type === 'error' ? 'error' : 'success'}`}>
                    {shareMessage.text}
                </div>
            )}

            <div className='lawPag_header'>
                <Link className='home-btn' to='/'>
                <GrHomeRounded />
                </Link>
                <Link to={'https://lawnex.app/'} className='new_laws_page'>
                بحث موسع في LawNex
                </Link>
            </div>
                <div className="search_container" ref={searchContainerRef} data-aos='fade-up'>
                    <img className='search_logo' src={logo} alt='logo_albarede' />
                    <h1>المكتبة القانونية</h1>
                    <div className={`search_bar_group ${isFocused ? 'search_focused' : ''}`}>
                        <input
                            type="text"
                            className='search_bar'
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setIsFocused(true); // تفعيل وضع التركيز/النتائج عند البدء بالكتابة
                            }}
                            placeholder="اكتب رقم القانون أو أي كلمات مفتاحية مناسبة.."
                            onKeyDown={handleEnterPress}
                        />
                    <button onClick={handleSearch}><IoMdSearch/></button>
                    </div>
                    
                </div>
                <button 
                className={`filter_bar_mobile ${isSidebarOpen ? 'active' : ''}`}
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                    <BsSliders />
                </button>
                {isSidebarOpen && <div className="filters_overlay" onClick={() => setIsSidebarOpen(false)}></div>}
            <div className={`filters_sidebar ${isSidebarOpen ? 'active' : ''} ${isFocused ? 'focused' : ''}`}>
            <div className='filter_sidbar_head'>
                <div className='filter_sidbar_head_logo'>
                    <Link>
                        {/* استخدام مسار الشعار كما هو مقدم في الكود الأصلي */}
                        <img src={logo} alt='logo' /> 
                        <p>شركة البريدي للمحاماة</p>
                    </Link>
                    <h1>المكتبة القانونية</h1>
                </div>
                <div className='filter_sidbar_head_title'>
                <BsSliders />
                <h4>بحث وتصفية</h4>
                <IoChevronBack className="close_sidebar_btn" onClick={() => setIsSidebarOpen(false)} />
                </div>
            </div>

            {/* **1. تصنيف (Category) - باستخدام FilterDropdown** */}
            <FilterDropdown
                title="التصنيف"
                value={categoryFilter}
                onChange={setCategoryFilter}
                icon={<BsBoxSeam />}
                options={categories.map(cat => ({ value: cat, label: cat }))}
                isIconMode={!isSidebarOpen && isIconMode}
            />

            {/* **2. النوع (Type) - باستخدام FilterDropdown** */}
            <FilterDropdown
                title="النوع"
                value={typeFilter}
                onChange={setTypeFilter}
                icon={<BsFileEarmarkText />}
                options={types.map(type => ({ value: type, label: type }))}
                isIconMode={!isSidebarOpen && isIconMode}
            />

            {/* **3. الجهة (Source) - باستخدام FilterDropdown** */}
            <FilterDropdown
                title="الجهة"
                value={sourceFilter}
                onChange={setSourceFilter}
                icon={<BsBuilding />}
                options={sources.map(src => ({ value: src, label: src }))}
                isIconMode={!isSidebarOpen && isIconMode}
            />

            {/* **4. العام (Year) - باستخدام FilterDropdown** */}
            <FilterDropdown
                title="العام"
                value={yearFilter}
                onChange={setYearFilter}
                icon={<BsCalendar />}
                options={years.map(year => ({ value: year, label: year }))}
                isIconMode={!isSidebarOpen && isIconMode}
            />

            {/* **5. الحالة (Enforced) - باستخدام FilterDropdown** */}
            <FilterDropdown
                title="الحالة"
                value={enforcedFilter}
                onChange={setEnforcedFilter}
                icon={enforcedFilter === "1" ? <BsCheckCircle /> : enforcedFilter === "0" ? <BsXCircle /> : <BsCheckCircle />}
                options={[
                    { value: "1", label: "نافذ" },
                    { value: "0", label: "ملغى" }
                ]}
                isIconMode={!isSidebarOpen && isIconMode}
            />

            <button className="filter_search_btn" onClick={handleSearch}>بحث وتصفية</button>
        </div>

            <div className="results_content">
                <div className="results_header">
                    <p className="total_results">إجمالي النتائج: {totalResults}</p>
                    <div className="pagination_controls">
                        <button onClick={handlePrevPage} disabled={currentPage === 1} className="pagination_btn">
                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.5.7 33.1L201 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127.1-127.1z"></path></svg>
                        </button>
                        <span>{`الصفحة ${currentPage} من ${totalPages}`}</span>
                        <button onClick={handleNextPage} disabled={currentPage * resultsPerPage >= totalResults} className="pagination_btn">
                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.5-.7 33.1L311 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"></path></svg>
                        </button>
                    </div>
                </div>

                <div className={`results_container ${isTextSearchMode ? 'full_width_results' : 'search_results_grid'}`}>
                    {loading && <LawCardSkeleton count={resultsPerPage} />}
                    {!loading && Array.isArray(laws) && laws.length > 0 ? (
                        laws.map(law =>  (
                            <div 
                                key={law.id} 
                                className={`law_card ${isTextSearchMode ? 'law_card_search_result' : 'law_card_compact'}`}
                            >
                                <div className="card_header">
                                    <div className='card_header_title'>
                                        <FaRegFileAlt />
                                        <Link to={`/law/${law.id}`} title={law.titl}>
                                            <h3 className="law_title">
                                                {highlightSearchTerms(law.title.substring(0, 80), searchTerm)}..
                                            </h3>
                                        </Link>
                                    </div>
                                    <div className='law_meta'>
                                        <p>
                                            <LuTag/>
                                            <span>{law.type_name} . </span>
                                            <span>رقم {law.law_number} . </span>
                                            <span>لعام {law.issue_year}</span>
                                        </p>
                                        <p>
                                            <BsBookmarks />
                                            <span>{law.category_name}</span>
                                            <span className={`law_status ${law.is_enforced ? 'enforced' : 'not_enforced'}`}>
                                                {law.is_enforced ? 'نافذ' : 'ملغى'}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                
                                <div className="law_section">
                                    {/* إظهار الديباجة والمقتطفات فقط في وضع البحث النصي */}
                                    {isTextSearchMode && law.preamble && ( // إظهار الديباجة في وضع البحث إذا لم يكن هناك مقتطفات
                                        <div className='preamble_text'>
                                            <h4 className="articles_title">ديباجة القانون:</h4>
                                            <p>
                                                {law.preamble.length > 300 
                                                    ? `${law.preamble.substring(0, 300)}...`
                                                    : law.preamble}
                                            </p>
                                        </div>
                                    )}

                                    {/* هذا الجزء سيعرض فقط المقتطفات (Snippets) عند وجود بحث */}
                                    {isTextSearchMode && law.snippets && law.snippets.length > 0 && ( 
                                        <div className='snippets_container'>
                                            <h4 className="articles_title">مقتطفات مطابقة للبحث:</h4>
                                            {law.snippets.slice(0, 3).map((snippet, index) => (
                                                <div key={index} className="article_snippet">
                                                    <p><strong>المادة {snippet.article_number}:</strong></p>
                                                    <p>{highlightSearchTerms(snippet.snippet_text, searchTerm)}</p>
                                                </div>
                                            ))}
                                            {law.snippets.length > 3 && <p className="more_snippets">... والمزيد من المواد المطابقة داخل القانون.</p>}
                                        </div>
                                    )}
                                </div>
                                
                                <div className='details_btn'>
                                    {/* **زر المشاركة المضاف** */}
                                    <button 
                                        className="share_btn" 
                                        onClick={() => handleShare(law.title, law.id)} 
                                        title="مشاركة القانون"
                                    >
                                        <BsShare />
                                    </button>
                                    
                                    <Link to={`/law/${law.id}`}>عرض التفاصيل</Link>
                                </div>
                            </div>
                        ))
                    ) : (
                        !loading && <p className="no_results">لا توجد نتائج بحث.</p>
                    )}
                <div className="results_header bottom">
                    <p className="total_results">انتقل الى الصفحة التالية</p>
                    <div className="pagination_controls">
                        <button onClick={handlePrevPage} disabled={currentPage === 1} className="pagination_btn">
                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.5.7 33.1L201 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127.1-127.1z"></path></svg>
                        </button>
                        <span>{`الصفحة ${currentPage} من ${totalPages}`}</span>
                        <button onClick={handleNextPage} disabled={currentPage * resultsPerPage >= totalResults} className="pagination_btn">
                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.5-.7 33.1L311 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"></path></svg>
                        </button>
                    </div>
                </div>
                </div>
            </div>
            <div className="lawnex-card" >
                <div className="lawnex-shine"></div>
                    <div className="lawnex-inner">
                        <div className="lawnex-logo">
                                  <img src={lawnexLogo} className="lawnex-icon" alt='logoLawnex'/>
                                  <div>
                                  <div className="lawnex-name">LAWNEX</div>
                                  <div className="lawnex-tagline">{t('LawnexSlogan')}</div>
                        </div>
                              <p className="lawnex-desc">{t('LawnexDisc')}</p>
                        <div className='DownloadsBtn'>
                               <a className='DownBtn' href='https://play.google.com/store/apps/details?id=com.lawnex.app&pcampaignid=web_share' title='google play'>
                                  <RiGooglePlayFill/>
                                  <div>
                                    <span>GET IN ON</span>
                                    <p>Google Play</p>
                                  </div>
                               </a>
                               <a className='DownBtn' href='https://apps.apple.com/us/app/lawnex/id6771798710' title='App store'>
                                  <FaApple/>
                                  <div>
                                    <span>Download on the</span>
                                    <p>App Store</p>
                                  </div>
                               </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Laws;
